"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepWithin = void 0;
const _ = require("lodash");
const deepWithin = (value, options) => {
    let isWithin = false;
    (options.options || []).map((o) => {
        isWithin = isWithin || _.isEqual(o, value);
    });
    if (!isWithin) {
        return options.message || "^The chosen option is not valid";
    }
};
exports.deepWithin = deepWithin;
//# sourceMappingURL=deepWithin.js.map